import { render, staticRenderFns } from "./RiwayatAsetTakBerwujudPage.vue?vue&type=template&id=27356efc"
import script from "./RiwayatAsetTakBerwujudPage.vue?vue&type=script&lang=js"
export * from "./RiwayatAsetTakBerwujudPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports